import { Link } from 'react-router-dom';
import { eventsData } from '../../../mocks/events';

export default function UpcomingEvents() {
  const events = eventsData.upcoming;

  return (
    <section className="py-24 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">What's Coming</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">Upcoming Events</h2>
          <div className="w-20 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-white/60 text-base max-w-xl mx-auto">
            Don't miss out on Benin City's most exclusive nights. Reserve your spot before it's gone.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {events.map((event, index) => (
            <div
              key={index}
              className="group relative rounded-xl overflow-hidden border border-zinc-800 hover:border-amber-500/50 transition-all duration-500 cursor-pointer"
            >
              <div className="relative h-80 overflow-hidden">
                <img
                  src={event.image}
                  alt={event.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="bg-amber-500 text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                    Upcoming
                  </span>
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <p className="text-amber-400 text-xs font-semibold tracking-widest uppercase mb-2">
                  {event.date}
                </p>
                <h3 className="text-white text-xl font-bold mb-2">{event.title}</h3>
                <p className="text-white/70 text-sm leading-relaxed line-clamp-2">{event.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/events"
            className="inline-flex items-center space-x-2 border border-amber-500 text-amber-500 hover:bg-amber-500 hover:text-black px-8 py-3 rounded-full text-sm font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <span>View All Events</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
